  (function() {
    var section = document.querySelector('.pdp-a');
    if (!section) return;

    /* Mark as JS-active (for no-JS fallback CSS) */
    section.classList.add('has-js');

    /* Track listeners + timers so we can clean up on shopify:section:unload */
    var teardown = [];
    function on(target, event, handler, opts) {
      target.addEventListener(event, handler, opts);
      teardown.push(function() { target.removeEventListener(event, handler, opts); });
    }
    function cleanup() {
      teardown.forEach(function(fn) { try { fn(); } catch(e) {} });
      teardown.length = 0;
    }

    /* Live region helper */
    var liveRegion = section.querySelector('[data-pdp-live]');
    function announce(msg) {
      if (!liveRegion) return;
      liveRegion.textContent = '';
      setTimeout(function() { liveRegion.textContent = msg; }, 50);
    }

    /* ═══════════════ Gallery ═══════════════ */
    /* The gallery column uses pure CSS: position: sticky on .pdp-a__gallery-inner
       keeps it pinned below the header. No JS positioning needed. */
    var track = section.querySelector('[data-gallery-track]');
    var slidesAll = section.querySelectorAll('.pdp-a__gallery-slide');
    var thumbsAll = section.querySelectorAll('[data-thumb-index]');
    var dotsAll = section.querySelectorAll('.pdp-a__gallery-dot');
    /* Visible subsets — rebuilt by applyFilter() each time the user
       switches timber or context. Initialized with the full set so the
       gallery is fully functional during the brief window before the
       first applyFilter() call runs at init. After applyFilter() runs,
       these arrays carry only the slides whose data-timber/-context match
       the active filter; everything else gets .is-filtered-out (CSS
       display:none, removed from flex layout). */
    var slides = Array.prototype.slice.call(slidesAll);
    var thumbs = Array.prototype.slice.call(thumbsAll);
    var dots = Array.prototype.slice.call(dotsAll);
    var current = 0;
    var total = slides.length;

    /* Filter state — see applyFilter() below for the controller. Default
       context is 'out' so the cross-doc View Transition pair from the
       homepage lineup card to the PDP first-visible slide stays
       consistent on initial load (the admin position-0 image is always
       spruce:out:1 — matching the Carbonized Nordic Spruce default-selected timber). */
    var hasIndoorMode = section.dataset.pdpHasIndoor === 'true';
    var activeFilter = { timber: null, context: 'out' };

    /* ── Deferred-slide hydration (2026-07-11 perf) ──
       Liquid ships only the active timber's first two slides with a real
       src (see custom-pdp-main-a.liquid slide budget); every other slide
       carries data-bettr-src/-srcset/-sizes. Hydrate = copy those onto the
       img. Idempotent. Fired from: (1) idle after window load, (2) first
       pointer contact with the gallery, (3) timber change in selectCard()
       — before applyFilter() reveals the other timber's slides. */
    /* 2026-10-19 (felt speed): the first slide shows a 48px blurred version of
       itself as its own background until the real file paints, so the sauna's
       shape is on screen within the first paint instead of a grey box. */
    Array.prototype.forEach.call(section.querySelectorAll('.pdp-a__gallery-slide[data-lqip]'), function(cell) {
      var tiny = cell.getAttribute('data-lqip');
      var img = cell.querySelector('img');
      if (!tiny || !img) return;
      var clear = function() { img.style.backgroundImage = ''; cell.removeAttribute('data-lqip'); };
      if (img.complete && img.naturalWidth > 0) { cell.removeAttribute('data-lqip'); return; }
      img.style.backgroundImage = 'url("' + tiny + '")';
      img.style.backgroundSize = 'contain';
      img.style.backgroundRepeat = 'no-repeat';
      img.style.backgroundPosition = 'center';
      img.addEventListener('load', clear, { once: true });
      img.addEventListener('error', clear, { once: true });
    });

    function hydrateImg(img) {
        var src = img.getAttribute('data-bettr-src');
        if (!src) return;
        img.sizes = img.getAttribute('data-bettr-sizes') || '';
        img.srcset = img.getAttribute('data-bettr-srcset') || '';
        img.src = src;
        img.loading = 'lazy';
        img.removeAttribute('data-bettr-defer');
        img.removeAttribute('data-bettr-src');
        img.removeAttribute('data-bettr-srcset');
        img.removeAttribute('data-bettr-sizes');
        /* Heal any slide the broken-media sweep hid while this img was
           src-less (see init sweep) — without this the slide stays
           display:none forever even though the image now loads fine. */
        var cell = img.closest('.pdp-a__gallery-slide, .pdp-a__gallery-thumb');
        if (cell) cell.removeAttribute('hidden');
    }
    /* 2026-10-18 (speed): hydrate on demand, never the whole strip. A real
       iPhone was downloading all 24 slides as 400–940KB PNGs (~14MB) because
       the idle sweep below hydrated every deferred slide at once. Now only
       the visible slides around the current one get a src; the rest wait
       for a swipe, an arrow, a thumb, or a timber/context change. */
    function hydrateAround(radius) {
      var list = slides;
      /* the visible thumb rail is six small images; keep it complete */
      thumbs.forEach(function(t) { var ti = t.querySelector('img[data-bettr-defer]'); if (ti) hydrateImg(ti); });
      for (var i = Math.max(0, current - radius); i <= Math.min(list.length - 1, current + radius); i++) {
        var cell = list[i];
        var img = cell && cell.querySelector('img[data-bettr-defer]');
        if (img) hydrateImg(img);
        var thumb = thumbs[i] && thumbs[i].querySelector('img[data-bettr-defer]');
        if (thumb) hydrateImg(thumb);
      }
    }
    function hydrateDeferredSlides() { hydrateAround(2); }
    if (track) {
      /* First finger/cursor on the gallery = the user is about to browse
         slides. Listens on .pdp-a__gallery (covers the track AND the
         thumb rail + arrows + dots). Capture-phase + once so it costs
         nothing afterward. */
      var galleryRoot = section.querySelector('.pdp-a__gallery') || track;
      ['pointerdown', 'touchstart'].forEach(function(evt) {
        on(galleryRoot, evt, hydrateDeferredSlides,
           { capture: true, passive: true, once: true });
      });
      /* Post-load idle: fill the strip in the background so an
         interaction-free swipe still finds every slide ready. */
      var idleHydrate = function() {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(function() { hydrateAround(1); }, { timeout: 3000 });
        } else {
          setTimeout(function() { hydrateAround(1); }, 1500);
        }
      };
      if (document.readyState === 'complete') {
        idleHydrate();
      } else {
        on(window, 'load', idleHydrate, { once: true });
      }
    }

    function goTo(index, opts) {
      opts = opts || {};
      if (index < 0) index = 0;
      if (index >= total) index = total - 1;
      var changed = (index !== current);
      current = index;
      if (track) track.style.transform = 'translateX(-' + (current * 100) + '%)';
      hydrateAround(1);

      thumbs.forEach(function(t, i) {
        var active = (i === current);
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
      dots.forEach(function(d, i) {
        var active = (i === current);
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
        d.setAttribute('tabindex', active ? '0' : '-1');
      });

      if (changed && !opts.silent) {
        announce('Image ' + (current + 1) + ' of ' + total);
      }

      /* 2026-07-11: a hydrated-but-still-fetching slide painted as a bare
         cream cell when the user outran the network (captured live on the
         cedar switch + fast arrow clicks). Shimmer the cell until its
         image lands. */
      var curSlide = slides[current];
      if (curSlide) {
        var curImg = curSlide.querySelector('img');
        if (curImg && curImg.getAttribute('src') && !curImg.complete) {
          curSlide.classList.add('bettr-skeleton');
          var unskeleton = function () { curSlide.classList.remove('bettr-skeleton'); };
          curImg.addEventListener('load', unskeleton, { once: true });
          curImg.addEventListener('error', unskeleton, { once: true });
        }
      }

      /* Keep the active thumb scrolled into view (since strip has overflow-x). */
      if (thumbs[current] && thumbs[current].scrollIntoView) {
        try {
          thumbs[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        } catch (e) {}
      }

      /* Keep arrow-disabled states in sync */
      if (typeof updateArrowState === 'function') updateArrowState();

      if (opts.focus === 'thumb' && thumbs[current]) thumbs[current].focus();
      if (opts.focus === 'dot' && dots[current]) dots[current].focus();
    }

    /* Thumb/dot click + keyboard (WAI-ARIA tabs pattern).
       Wires every node in the FULL NodeList (`thumbsAll` / `dotsAll`).
       Each handler looks up the bound element's index in the LIVE
       visible array (`thumbs` / `dots`) — so when the filter shrinks
       the visible set, arrow-key bounds + click targets stay correct.
       Filtered-out nodes don't receive clicks (display:none) and bail
       early on keyboard if the user reaches them via direct focus. */
    function wireTabs(allNodes, focusKey) {
      var live = focusKey === 'thumb' ? function() { return thumbs; } : function() { return dots; };
      Array.prototype.forEach.call(allNodes, function(node) {
        on(node, 'click', function() {
          var idx = live().indexOf(node);
          if (idx >= 0) goTo(idx);
        });
        on(node, 'keydown', function(e) {
          var arr = live();
          var idx = arr.indexOf(node);
          if (idx < 0) return;
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = Math.min(arr.length - 1, idx + 1);
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = Math.max(0, idx - 1);
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = arr.length - 1;
          if (next !== null) {
            e.preventDefault();
            goTo(next, { focus: focusKey });
          }
        });
      });
    }
    wireTabs(thumbsAll, 'thumb');
    wireTabs(dotsAll, 'dot');

    /* Main-image prev/next arrows — always enabled, wrap around at ends
       (matches Eight Sleep: prev from image 1 jumps to the last image,
       next from the last image jumps to image 1). */
    var galleryPrev = section.querySelector('[data-gallery-prev]');
    var galleryNext = section.querySelector('[data-gallery-next]');
    var galleryMain = section.querySelector('.pdp-a__gallery-main');
    function updateArrowState() { /* no-op: arrows never disable */ }
    if (galleryPrev) on(galleryPrev, 'click', function() {
      goTo(current === 0 ? total - 1 : current - 1);
    });
    if (galleryNext) on(galleryNext, 'click', function() {
      goTo(current === total - 1 ? 0 : current + 1);
    });

    /* ── Adaptive arrow theme ──
       Default = dark frosted pill (visible on light/white + safe fallback).
       On confirmed-dark imagery we upgrade to ".is-dark-bg" = light frosted
       glass (Eight Sleep style).
       If the sampler fails (CORS, lazy-load timing), the visible dark
       default stays in place.

       Sampling region (updated 2026-04-18): 12% wide × 40% tall, centered
       vertically. Previously sampled full-height strips, which averaged in
       top/bottom whitespace and product middles that don't live behind the
       arrows (arrows sit at ~95% horizontal, ~50% vertical). On back-of-
       product or angle shots where the product's dark trim (hexagonal roof,
       hinges, metal supports) lived above/below the arrow position, the
       full-height strip dragged the average below threshold and wrongly
       flipped the arrow to .is-dark-bg — producing a near-invisible white
       frosted pill on a white background. Narrower sample fixes that by
       measuring only the band the arrow actually sits on top of.

       Threshold 125 (was 130): slight safety margin favouring the default
       dark pill on borderline luma, since the false-positive case (white
       pill on light bg) reads worse than the false-negative (dark pill on
       dark bg — still legible via white chevron). ── */
    var brightnessCache = Object.create(null);
    var DARK_BG_THRESHOLD = 125;  /* 0..255 perceived luma — below this → .is-dark-bg (light frosted pill) */
    var LIGHT_BG_THRESHOLD = 200; /* above this → .is-light-bg (more opaque dark pill, dark chevron).
                                     Default range 125–200 = mid-luminance imagery (lifestyle, mid-grey
                                     backdrops) where the default 32%-black pill + white chevron is
                                     legible on its own. */

    /* Cream cell background — must match .pdp-a__gallery-main bg
       (--bg-1 #F9F8F7). Used below to composite alpha properly before
       computing luma. Transparent PNG pixels (alpha=0) commonly store
       RGB=0,0,0 from the Figma export, but visually they render as the
       cell's cream background showing through. Sampling RGB without
       alpha would classify the sample as dark imagery and apply
       .is-dark-bg (light frosted glass) — invisible on cream. Compose
       against cream first; THEN luma. See mistakes.md 2026-05-20. */
    var CELL_BG_R = 0xF9, CELL_BG_G = 0xF8, CELL_BG_B = 0xF7;
    function avgLuma(data) {
      var sum = 0, count = data.length / 4;
      for (var i = 0; i < data.length; i += 4) {
        var a = data[i + 3] / 255;
        var inv = 1 - a;
        var r = data[i]     * a + CELL_BG_R * inv;
        var g = data[i + 1] * a + CELL_BG_G * inv;
        var b = data[i + 2] * a + CELL_BG_B * inv;
        sum += 0.299 * r + 0.587 * g + 0.114 * b;
      }
      return sum / count;
    }

    function sampleArrowRegions(img, cb) {
      if (!img) return cb({ prev: null, next: null });
      function run() {
        var nw = img.naturalWidth;
        var nh = img.naturalHeight;
        if (!nw || !nh) return cb({ prev: null, next: null });

        /* Sample zones matched to the arrows' on-screen position:
           outer 12% width × middle 40% height. Scaled to 8x24 for fast avg. */
        var sw = Math.max(1, Math.floor(nw * 0.12));
        var sh = Math.max(1, Math.floor(nh * 0.40));
        var sy = Math.floor((nh - sh) / 2);
        var sxRight = Math.max(0, nw - sw);

        var canvas = document.createElement('canvas');
        canvas.width = 8;
        canvas.height = 24;
        var ctx = canvas.getContext('2d');
        try {
          ctx.drawImage(img, 0, sy, sw, sh, 0, 0, 8, 24);
          var prevLum = avgLuma(ctx.getImageData(0, 0, 8, 24).data);

          ctx.clearRect(0, 0, 8, 24);
          ctx.drawImage(img, sxRight, sy, sw, sh, 0, 0, 8, 24);
          var nextLum = avgLuma(ctx.getImageData(0, 0, 8, 24).data);

          cb({ prev: prevLum, next: nextLum });
        } catch (err) {
          cb({ prev: null, next: null });
        }
      }
      if (img.complete && img.naturalWidth) {
        run();
      } else {
        img.addEventListener('load', run, { once: true });
        img.addEventListener('error', function() { cb({ prev: null, next: null }); }, { once: true });
      }
    }

    function applyArrowTheme(idx) {
      /* Adaptive theming disabled for transparent product renders. The
         sampler reads a 12% × 40% strip on each side of the natural
         image; for our PNGs the sauna body fills that strip (opaque,
         dark) but the arrow ACTUALLY sits over a different part of the
         strip — sometimes on opaque sauna, sometimes on a transparent
         pixel that renders as cream cell background. Two cases:
           - Sampler says "dark" → applies .is-dark-bg (light frosted
             glass). When the arrow's real backdrop is the dark sauna,
             this looks great. When it's the cream (transparent pixel
             showing the cell bg), it's INVISIBLE.
           - Sampler says "light" → applies .is-light-bg (opaque dark
             pill). Works on cream, looks heavier than needed on dark
             sauna.
         The sample region is too coarse to predict the arrow's actual
         backdrop on a per-pixel basis. The default style
         (rgba(17,20,16,0.32) + backdrop-filter blur + white chevron)
         is legible on BOTH backgrounds — that's why it's the default.
         Disabling the class toggle until we either re-render the
         product imagery as opaque lifestyle shots OR move the arrows
         to a position outside the image (where the bg is always cream).
         See mistakes.md 2026-05-20. */
      if (galleryPrev) galleryPrev.classList.remove('is-dark-bg', 'is-light-bg');
      if (galleryNext) galleryNext.classList.remove('is-dark-bg', 'is-light-bg');
    }

    /* Hook theme update into goTo */
    var _goTo = goTo;
    goTo = function(index, opts) {
      _goTo(index, opts);
      applyArrowTheme(current);
    };

    /* Initial apply */
    applyArrowTheme(current);

    /* Thumb strip scroll arrows */
    var thumbStrip = section.querySelector('[data-gallery-thumbs]');
    var thumbPrev = section.querySelector('[data-thumb-prev]');
    var thumbNext = section.querySelector('[data-thumb-next]');
    function updateThumbArrows() {
      if (!thumbStrip) return;
      if (thumbPrev) thumbPrev.disabled = thumbStrip.scrollLeft <= 2;
      if (thumbNext) thumbNext.disabled = (thumbStrip.scrollLeft + thumbStrip.clientWidth) >= (thumbStrip.scrollWidth - 2);
    }
    function scrollThumbs(dir) {
      if (!thumbStrip) return;
      var step = thumbStrip.clientWidth * 0.75;
      thumbStrip.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    if (thumbPrev) on(thumbPrev, 'click', function() { scrollThumbs(-1); });
    if (thumbNext) on(thumbNext, 'click', function() { scrollThumbs(1); });
    if (thumbStrip) {
      on(thumbStrip, 'scroll', function() {
        window.requestAnimationFrame(updateThumbArrows);
      }, { passive: true });
      /* Initial state after layout settles */
      window.requestAnimationFrame(updateThumbArrows);
    }

    /* ── Hide broken media gracefully ──
       If a product image fails to load (deleted/expired in admin),
       hide the failing thumb/slide so the user doesn't see the browser
       broken-image glyph. Listener added in capture phase since `error`
       doesn't bubble. */
    function handleMediaError(e) {
      var t = e.target;
      if (!t || t.tagName !== 'IMG') return;
      var thumb = t.closest('.pdp-a__gallery-thumb');
      var slide = t.closest('.pdp-a__gallery-slide');
      if (thumb) thumb.setAttribute('hidden', '');
      if (slide) slide.setAttribute('hidden', '');
      if (thumb || slide) window.requestAnimationFrame(updateThumbArrows);
    }
    on(section, 'error', handleMediaError, true);
    /* Also sweep images already loaded at JS init (if any failed before listener attached).
       Deferred slides (data-bettr-defer) have NO src yet — the HTML spec makes a
       src-less <img> report complete:true + naturalWidth:0, which reads as
       "broken" here and permanently hid every deferred slide (blank gallery on
       timber switch / swipe past slide 2). Only sweep imgs that actually have a src. */
    section.querySelectorAll('.pdp-a__gallery-thumb img, .pdp-a__gallery-slide img').forEach(function(img) {
      if (img.hasAttribute('data-bettr-defer') || !img.getAttribute('src')) return;
      if (img.complete && img.naturalWidth === 0) {
        handleMediaError({ target: img });
      }
    });

    /* Touch swipe */
    if (track) {
      var startX = 0, startY = 0, deltaX = 0, isDragging = false, isHorizontal = null, trackWidth = 0;

      on(track, 'touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        deltaX = 0;
        isDragging = true;
        isHorizontal = null;
        trackWidth = track.offsetWidth;
        track.classList.add('is-dragging');
      }, { passive: true });

      on(track, 'touchmove', function(e) {
        if (!isDragging) return;
        deltaX = e.touches[0].clientX - startX;
        var deltaY = e.touches[0].clientY - startY;
        if (isHorizontal === null && (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5)) {
          isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
        }
        if (isHorizontal) {
          e.preventDefault();
          var offset = -(current * 100) + (deltaX / trackWidth) * 100;
          track.style.transform = 'translateX(' + offset + '%)';
        }
      }, { passive: false });

      on(track, 'touchend', function() {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
        if (isHorizontal) {
          var threshold = trackWidth * 0.2;
          if (deltaX < -threshold) goTo(current + 1);
          else if (deltaX > threshold) goTo(current - 1);
          else goTo(current);
        }
      }, { passive: true });

      /* Mouse drag — scoped to mousedown lifecycle (no global leak) */
      on(track, 'mousedown', function(e) {
        var mouseStartX = e.clientX;
        var mouseDelta = 0;
        var mTrackWidth = track.offsetWidth;
        track.classList.add('is-dragging');
        e.preventDefault();

        function onMove(ev) {
          mouseDelta = ev.clientX - mouseStartX;
          track.style.transform = 'translateX(' + (-(current * 100) + (mouseDelta / mTrackWidth) * 100) + '%)';
        }
        function onUp() {
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', onUp);
          track.classList.remove('is-dragging');
          var threshold = mTrackWidth * 0.2;
          if (mouseDelta < -threshold) goTo(current + 1);
          else if (mouseDelta > threshold) goTo(current - 1);
          else goTo(current);
        }
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
      });
    }

    /* ═══════════════ Gallery filter (timber + Outdoor/Indoor context) ═══════════════ */
    /* Each slide / dot / thumb carries data-timber / data-context / data-slot
       attributes parsed from img.alt in Liquid (`<timber>:<context>:<slot>`).
       applyFilter() recomputes the visible subsets, toggles .is-filtered-out
       on the full NodeLists (CSS display:none removes them from flex layout),
       resets the active slide to 0, busts the arrow-theme luma cache, and
       dispatches `bettr:gallery-filter-change` for Phase 21 observability.

       Called from:
         - initial JS setup below (default state from radiogroup + 'out')
         - selectCard() when kind === 'Timber' (timber radiogroup change)
         - context tab click + keyboard handlers (only when hasIndoorMode). */
    function matchesFilter(el) {
      var t = el.dataset.timber;
      var c = el.dataset.context;
      /* Empty data attrs (legacy media with an alt that doesn't parse) →
         always visible. Lets the gallery degrade gracefully if a merchant
         uploads a non-conventional image. */
      if (!t && !c) return true;
      if (activeFilter.timber && t && t !== activeFilter.timber) return false;
      if (hasIndoorMode && activeFilter.context && c && c !== activeFilter.context) return false;
      return true;
    }

    function applyFilter(opts) {
      opts = opts || {};
      slides = Array.prototype.filter.call(slidesAll, matchesFilter);
      thumbs = Array.prototype.filter.call(thumbsAll, matchesFilter);
      dots = Array.prototype.filter.call(dotsAll, matchesFilter);
      total = slides.length;

      function syncVisibility(nodeList, visibleArr) {
        Array.prototype.forEach.call(nodeList, function(el) {
          el.classList.toggle('is-filtered-out', visibleArr.indexOf(el) === -1);
        });
      }
      syncVisibility(slidesAll, slides);
      syncVisibility(thumbsAll, thumbs);
      syncVisibility(dotsAll, dots);

      /* Reset to first visible slide. translateX(0) holds because hidden
         slides are display:none (removed from flex layout), so visible
         slides start at the left edge of the track. */
      current = 0;
      if (track) track.style.transform = 'translateX(0)';

      /* Sync active state on the new first-visible thumb + dot. */
      thumbs.forEach(function(t, i) {
        var active = (i === 0);
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
      dots.forEach(function(d, i) {
        var active = (i === 0);
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
        d.setAttribute('tabindex', active ? '0' : '-1');
      });

      /* Different first-visible slide → different luma profile under the
         prev/next arrows → drop the cache so the theme re-samples. */
      brightnessCache = Object.create(null);
      applyArrowTheme(0);

      if (!opts.silent) {
        section.dispatchEvent(new CustomEvent('bettr:gallery-filter-change', {
          detail: {
            timber: activeFilter.timber,
            context: activeFilter.context,
            visibleCount: total
          },
          bubbles: true
        }));
      }
    }

    /* Context tabs (Outdoor / Indoor) — rendered only when the section has
       data-pdp-has-indoor="true" (set in Liquid after pre-scanning for any
       alt containing ':in:'). Wire clicks + WAI-ARIA tablist keyboard
       pattern (arrow keys move + auto-select, matching the existing
       thumb/dot tabs pattern). */
    var contextTabs = hasIndoorMode
      ? Array.prototype.slice.call(section.querySelectorAll('[data-context-tab]'))
      : [];

    function setContextTab(value) {
      if (value !== 'in' && value !== 'out') return;
      activeFilter.context = value;
      contextTabs.forEach(function(t) {
        var active = (t.dataset.contextTab === value);
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
      applyFilter();
      hydrateAround(1);
    }

    contextTabs.forEach(function(tab, idx) {
      on(tab, 'click', function() {
        setContextTab(tab.dataset.contextTab);
        tab.focus();
      });
      on(tab, 'keydown', function(e) {
        var move = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') move = 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') move = -1;
        else if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          setContextTab(tab.dataset.contextTab);
          return;
        }
        if (move === 0) return;
        e.preventDefault();
        var nextIdx = (idx + move + contextTabs.length) % contextTabs.length;
        var nextTab = contextTabs[nextIdx];
        setContextTab(nextTab.dataset.contextTab);
        nextTab.focus();
      });
    });

    /* ═══════════════ Timber / Heater selection + variant resolution ═══════════════ */
    var variantsScript = section.querySelector('[data-pdp-variants]');
    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent) || []; } catch (err) { variants = []; }
    }

    var cartForm = section.querySelector('[data-pdp-cart-form]');
    var variantIdInput = section.querySelector('[data-pdp-variant-id]');
    var addBtn = section.querySelector('[data-pdp-add-btn]');
    var priceEl = section.querySelector('[data-pdp-price]');
    var compareEl = section.querySelector('[data-pdp-compare]');
    var defaultAddLabel = addBtn ? addBtn.textContent.trim() : 'Add to Cart';
    /* Remembering picks stays off until the initial server-rendered state
       has settled, so plain visits keep a clean URL; user picks are then kept
       for refresh and Back (rememberVariant). */
    var urlSyncArmed = false;

    var selected = {
      timber: section.querySelector('[data-timber].is-selected'),
      heater: section.querySelector('[data-heater].is-selected')
    };

    function formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      var n = cents / 100;
      var s = n.toFixed(2);
      if (s.slice(-3) === '.00') s = s.slice(0, -3);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    function selectedOptionValue(stateKey) {
      var el = selected[stateKey];
      return el ? el.getAttribute('data-option-value') : null;
    }

    function findVariantFromSelection() {
      if (!variants.length) return null;
      var o1 = selectedOptionValue('timber');
      var o2 = selectedOptionValue('heater');
      if (!o1 || !o2) return null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === o1 && variants[i].option2 === o2) return variants[i];
      }
      return null;
    }

    /* Upgrade labels ("+$1,400" on cedar, "+$1,000" on Wi-Fi) are rendered from the
       cheapest variants, which is right for the default selection. Where a model prices
       the combinations unevenly (Ritual 2: cedar +$1,400 with Manual but +$1,500 with
       Wi-Fi; Wi-Fi +$1,000 on spruce but +$1,100 on cedar), each upgrade label is
       recomputed against the option picked in the other group, so it always matches
       the price step the buyer will see. The first card in each group is the base. */
    function variantPriceFor(o1, o2) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === o1 && variants[i].option2 === o2) return variants[i].price;
      }
      return null;
    }

    function refreshUpgradeDeltas() {
      var timber = selectedOptionValue('timber');
      var heater = selectedOptionValue('heater');
      if (!timber || !heater) return;
      [['.pdp-a__timber-card[data-timber]', true], ['.pdp-a__heater-card[data-heater]', false]].forEach(function(group) {
        var cards = section.querySelectorAll(group[0]);
        if (cards.length < 2) return;
        var base = cards[0].getAttribute('data-option-value');
        for (var i = 1; i < cards.length; i++) {
          var label = cards[i].querySelector('.pdp-a__price-delta:not(.pdp-a__price-delta--included)');
          if (!label) continue;
          var value = cards[i].getAttribute('data-option-value');
          var withUpgrade = group[1] ? variantPriceFor(value, heater) : variantPriceFor(timber, value);
          var withBase = group[1] ? variantPriceFor(base, heater) : variantPriceFor(timber, base);
          if (withUpgrade == null || withBase == null) continue;
          var step = withUpgrade - withBase;
          label.hidden = step <= 0;
          if (step > 0) label.textContent = '+' + formatMoney(step);
        }
      });
    }

    function updateFromVariant() {
      /* Phase 21 / P1.4 — User Timing mark for variant swap.
         Fires when a timber/heater selection produces a new variant.
         Useful to see how often users actually swap + how fast the
         UI reacts. */
      if (window.BettrMetrics && window.BettrMetrics.mark) {
        window.BettrMetrics.mark('variant-change');
      }
      var v = findVariantFromSelection();
      if (!v) {
        /* Surface misconfiguration during admin/dev; doesn't affect ATC button
           because availability + price stay at server-rendered defaults. */
        if (window.console && console.warn) {
          console.warn('[PDP] No variant matches the current timber/heater selection.');
        }
        return;
      }
      if (variantIdInput) variantIdInput.value = v.id;
      refreshUpgradeDeltas();
      var termsInput = section.querySelector('[data-pdp-terms-variant-id]');
      if (termsInput) {
        termsInput.value = v.id;
        termsInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }
      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-disabled');
          if (!addBtn.classList.contains('is-busy')) addBtn.textContent = defaultAddLabel;
        } else {
          addBtn.disabled = true;
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.textContent = 'Sold out';
        }
      }
      if (urlSyncArmed) rememberVariant(String(v.id));
    }

    /* A pick is kept in this history entry's state, not in the address:
       the chat bubble (ZipChat) checks the address every second and tears
       down and reloads its whole widget on any query change, so writing
       ?variant= on every wood or heater pick made the bubble vanish and
       slide back in (Viktor 31 Oct: "when you change the heaters the live
       chat flickers"). Refresh reads the state back (restoreVariantFromUrl),
       Back/Forward across size switches too (custom-pdp-model-swap.js), and
       ?variant= is written as the page unloads, so a Back that reloads the
       page gets the pick from the server. */
    var urlVariant = null;
    /* This section's own product, not the address: Back can move the address
       to another model before a swapped-in section's script has run. */
    var entryPath = window.location.pathname;
    try {
      var shareEl = section.querySelector('.pdp-a__share[data-url]');
      if (shareEl) entryPath = new URL(shareEl.getAttribute('data-url'), window.location.href).pathname;
    } catch (err) {}
    var PICK_KEY = 'bettr:pdp-pick:' + entryPath;
    var keptFromSession = null;
    function rememberVariant(id) {
      urlVariant = id;
      if (!window.history || !history.replaceState || (window.Shopify && Shopify.designMode)) return;
      /* Back/Forward already moved to another model's entry while this page
         is still on screen (custom-pdp-model-swap.js is loading it). */
      if (window.location.pathname !== entryPath) return;
      try { history.replaceState(Object.assign({}, history.state, { bettrVariant: id }), ''); } catch (err) {}
      /* WebKit drops history.state on a refresh; the tab's session keeps a copy. */
      try { window.sessionStorage.setItem(PICK_KEY, id); } catch (err) {}
    }
    function stampUrl() {
      if (!urlVariant || !window.history || !history.replaceState || (window.Shopify && Shopify.designMode)) return;
      if (window.location.pathname !== entryPath) return;
      try {
        var u = new URL(window.location.href);
        if (u.searchParams.get('variant') === urlVariant) return;
        u.searchParams.set('variant', urlVariant);
        history.replaceState(history.state, '', u);
      } catch (err) { /* URL API unavailable — skip silently */ }
    }

    function selectCard(cards, card, kind, stateKey, opts) {
      opts = opts || {};
      cards.forEach(function(c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-checked', 'false');
        c.setAttribute('tabindex', '-1');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-checked', 'true');
      card.setAttribute('tabindex', '0');
      selected[stateKey] = card;
      var name = card.querySelector('.pdp-a__timber-name, .pdp-a__heater-name');
      if (!opts.silent) announce(kind + ' selected: ' + (name ? name.textContent.trim() : ''));
      updateFromVariant();
      /* Timber change also drives the gallery filter. applyFilter +
         activeFilter are hoisted/declared up in the gallery section. */
      if (kind === 'Timber' && card.dataset.timber) {
        /* The other timber's slides shipped deferred (no src) — hydrate
           before applyFilter() reveals them so they paint immediately. */
        activeFilter.timber = card.dataset.timber;
        /* A timber tap shows the wood where it is visible: the interior.
           The exteriors are the same dark cladding, so the outdoor slides
           say nothing about the choice (felt review, 16 Oct; Viktor 20 Oct). */
        if (!opts.silent && hasIndoorMode && activeFilter.context !== 'in') {
          setContextTab('in');
        } else {
          applyFilter();
          hydrateAround(1);
        }
        /* On phones the gallery is two screens up: bring it back into view. */
        if (!opts.silent && window.matchMedia('(max-width: 989px)').matches) {
          var gal = section.querySelector('.pdp-a__gallery');
          if (gal) {
            var gr = gal.getBoundingClientRect();
            if (gr.top < 0 || gr.bottom > window.innerHeight) {
              var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 60;
              var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              window.scrollTo({ top: window.scrollY + gr.top - headerH - 8, behavior: reduce ? 'auto' : 'smooth' });
            }
          }
        }
      }
    }

    function wireSelectable(selector, kind, stateKey) {
      var cards = section.querySelectorAll(selector);
      cards.forEach(function(card, idx) {
        on(card, 'click', function() {
          selectCard(cards, card, kind, stateKey);
          card.focus();
        });
        /* WAI-ARIA radiogroup keyboard pattern: arrow keys move + auto-select. */
        on(card, 'keydown', function(e) {
          var key = e.key;
          var move = 0;
          if (key === 'ArrowRight' || key === 'ArrowDown') move = 1;
          else if (key === 'ArrowLeft' || key === 'ArrowUp') move = -1;
          else if (key === ' ' || key === 'Enter') {
            e.preventDefault();
            selectCard(cards, card, kind, stateKey);
            return;
          }
          if (move === 0) return;
          e.preventDefault();
          var n = cards.length;
          var nextIdx = (idx + move + n) % n;
          var nextCard = cards[nextIdx];
          selectCard(cards, nextCard, kind, stateKey);
          nextCard.focus();
        });
      });
    }
    /* Scope the timber selector to the actual radio cards. The gallery
       filter scaffold adds data-timber to slide/dot/thumb elements too,
       so the bare `[data-timber]` selector would treat every thumb click
       as a timber change — selectCard would then run applyFilter() and
       blow away goTo()'s transform on every thumb click. Same defensive
       scoping for heater (no current collision, but cheap insurance). */
    wireSelectable('.pdp-a__timber-card[data-timber]', 'Timber', 'timber');
    wireSelectable('.pdp-a__heater-card[data-heater]', 'Heater', 'heater');

    /* Deep-link restore: a shared ?variant= URL, or on refresh the pick
       kept for this history entry (rememberVariant), re-selects its timber + heater
       cards (silently — this is initial state, not a user action) before
       the initial filter/price sync below runs. */
    (function restoreVariantFromUrl() {
      if (!variants.length) return;
      var id = NaN;
      var kept = history.state && history.state.bettrVariant;
      /* Only for the page a refresh loaded, not one swapped in later. */
      if (!kept && !window.bettrPdpBooted) {
        try {
          var nav = performance.getEntriesByType('navigation')[0];
          if (nav && nav.type === 'reload') keptFromSession = kept = window.sessionStorage.getItem(PICK_KEY);
        } catch (err) {}
      }
      window.bettrPdpBooted = true;
      try { id = Number(kept || new URLSearchParams(window.location.search).get('variant')); } catch (err) { return; }
      if (!id) return;
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) { v = variants[i]; break; }
      }
      if (!v) return;
      [
        { sel: '.pdp-a__timber-card[data-timber]', kind: 'Timber', key: 'timber', value: v.option1 },
        { sel: '.pdp-a__heater-card[data-heater]', kind: 'Heater', key: 'heater', value: v.option2 }
      ].forEach(function(o) {
        var cards = section.querySelectorAll(o.sel);
        for (var j = 0; j < cards.length; j++) {
          if (cards[j].getAttribute('data-option-value') === o.value) {
            if (!cards[j].classList.contains('is-selected')) {
              selectCard(cards, cards[j], o.kind, o.key, { silent: true });
            }
            break;
          }
        }
      });
    })();

    /* Establish the initial gallery-filter state from the radiogroup's
       Liquid-pre-selected timber + default 'out' context. silent: true
       avoids dispatching the change event on initial paint (this is a
       static starting state, not a user-triggered change). */
    if (selected.timber && selected.timber.dataset.timber) {
      activeFilter.timber = selected.timber.dataset.timber;
    }
    applyFilter({ silent: true });

    /* Initial sync if product data is present */
    if (variants.length) updateFromVariant();
    urlSyncArmed = true;
    /* A pick a refresh brought back from the session goes into the entry
       again, so Back/Forward across a later size switch finds it. */
    if (keptFromSession && variantIdInput && variantIdInput.value === String(keptFromSession)) rememberVariant(variantIdInput.value);
    /* Only when the page really unloads: a page kept for Back (bfcache)
       comes back as it was, and a changed address would reload the chat. */
    on(window, 'pagehide', function(e) { if (!e.persisted) stampUrl(); });
    /* An in-page #link (the skip link, say) adds a history entry with no
       state: it carries the pick too, so Back across a later size switch
       still finds it. */
    on(window, 'hashchange', function() {
      if (urlVariant && !(history.state && history.state.bettrVariant)) rememberVariant(urlVariant);
    });

    /* ═══════════════ AJAX Add-to-Cart ═══════════════ */
    if (cartForm && addBtn && variantIdInput) {
      on(cartForm, 'submit', function(e) {
        /* If no variants JSON (e.g. preview mode), let native form POST fall through */
        if (!variants.length) return;
        e.preventDefault();
        if (addBtn.disabled || !variantIdInput.value) return;

        /* Phase 21 / P1.4 — User Timing paired marks for ATC click.
           Measure the full click → cart-add completion roundtrip. */
        var bm = window.BettrMetrics;
        if (bm && bm.mark) bm.mark('atc-click-start');

        addBtn.classList.add('is-busy');
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        /* Global progress cursor — the CSS selector html.is-busy *
           in layout/theme.liquid covers the whole page while the
           cart-add request is in flight. */
        document.documentElement.classList.add('is-busy');

        var restore = function(label) {
          addBtn.textContent = label;
          addBtn.classList.remove('is-busy');
          addBtn.disabled = false;
          document.documentElement.classList.remove('is-busy');
        };

        /* Bundle the sauna + any selected add-ons (Bettr Protect / Assembly / Shower)
           into a single /cart/add.js request. Falls back to sauna-only if the
           add-on controller hasn't loaded. */
        var cartItems = (window.BettrAddons && typeof window.BettrAddons.buildCartItems === 'function')
          ? window.BettrAddons.buildCartItems(variantIdInput.value)
          : [{ id: parseInt(variantIdInput.value, 10), quantity: 1 }];

        function postItems(items) {
          return fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: items })
          });
        }

        /* Card title for a variant id, so the announcement can name what was
           dropped instead of saying "an add-on". */
        function addonLabel(variantId) {
          var check = document.querySelector('[data-addon-variant-id="' + variantId + '"]');
          var card = check && check.closest('[data-addon-card]');
          var title = card && card.querySelector('.pdp-addons__title');
          return title ? title.textContent.trim() : '';
        }

        /* 2026-08-14 — never let an add-on take the sauna down with it.
           /cart/add.js is ATOMIC: one unavailable line item returns 422 and
           nothing is added, sauna included. A variant can sell out between
           page render and click, so the Liquid availability guard in
           snippets/custom-pdp-addons.liquid cannot be the only defence.

           2026-08-21 — the first version of this retry posted the sauna ALONE,
           so ONE unavailable add-on threw away every other add-on the buyer had
           ticked (assembly $880 + warranty $450 + shower $1,785 all lost to a
           sold-out shower), the button said "add-on" singular however many went,
           and the cards stayed visibly ticked while the cart held nothing for
           them. Atomicity is per REQUEST, so: post the sauna, then each add-on
           on its own. A failure now costs only that line, and only that card
           gets unticked. */
        var droppedAddons = [];
        postItems(cartItems)
        .then(function(r) {
          if (r.ok) return r.json();
          return r.json().catch(function() { return {}; }).then(function(j) {
            var addons = cartItems.slice(1);
            if (!addons.length) {
              throw new Error(j.description || j.message || 'Unable to add to cart');
            }
            return postItems([cartItems[0]]).then(function(r2) {
              if (!r2.ok) {
                throw new Error(j.description || j.message || 'Unable to add to cart');
              }
              return r2.json();
            }).then(function(saunaData) {
              var latest = saunaData;
              return addons.reduce(function(chain, item) {
                return chain.then(function() {
                  return postItems([item]).then(function(r3) {
                    if (!r3.ok) { droppedAddons.push(item); return; }
                    return r3.json().then(function(d) { latest = d; });
                  }).catch(function() { droppedAddons.push(item); });
                });
              }, Promise.resolve()).then(function() { return latest; });
            });
          });
        })
        .then(function(data) {
          if (bm && bm.mark) bm.mark('atc-click-end');
          if (bm && bm.measure) bm.measure('atc-click', 'atc-click-start', 'atc-click-end');
          var dropped = droppedAddons.length;
          if (dropped) {
            /* The sauna and every add-on that could be bought are in the cart.
               Name the rest, and untick them so the page stops claiming they
               are selected. */
            addBtn.textContent = dropped === 1
              ? 'Added — 1 add-on unavailable'
              : 'Added — ' + dropped + ' add-ons unavailable';
            var names = droppedAddons.map(function(i) { return addonLabel(i.id); })
                                     .filter(function(n) { return n; });
            var detail = names.length
              ? names.join(' and ') + (names.length === 1 ? ' is unavailable and was not added.'
                                                          : ' are unavailable and were not added.')
              : (dropped === 1 ? 'One add-on was unavailable and was not added.'
                               : dropped + ' add-ons were unavailable and were not added.');
            announce('Added to cart. ' + detail);
            if (window.BettrAddons && typeof window.BettrAddons.deselectVariant === 'function') {
              droppedAddons.forEach(function(i) { window.BettrAddons.deselectVariant(i.id); });
            }
          } else {
            addBtn.textContent = 'Added';
            announce('Added to cart');
          }
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
          setTimeout(function() { restore(defaultAddLabel); }, dropped ? 2600 : 1600);
        })
        .catch(function(err) {
          if (bm && bm.mark) bm.mark('atc-click-end');
          if (bm && bm.measure) bm.measure('atc-click-error', 'atc-click-start', 'atc-click-end');
          announce('Unable to add to cart');
          restore((err && err.message) ? err.message : 'Try again');
          setTimeout(function() { restore(defaultAddLabel); }, 2400);
        });
      });
    }

    /* ═══════════════ Help modals ═══════════════
       Migrated to native Popover API (<div popover="auto">). The browser
       owns Esc and focus return to the trigger; popover="auto" does not
       trap focus, so Tab is kept inside the open panel below.
       Trigger buttons use `popovertarget` + `popovertargetaction` — no JS.
       The body-scroll-lock :has() selector in layout/theme.liquid includes
       `.pdp-a__modal:popover-open` so opening one locks scroll.

       Outside-click dismiss: our popover wrapper fills the viewport
       (position:fixed; inset:0) to host the centered .pdp-a__modal-dialog,
       so the browser's native light-dismiss never sees an "outside" click
       — every click lands inside the popover element. We restore it by
       checking if the click target is the popover itself (not a descendant)
       and calling hidePopover(). */
    section.querySelectorAll('.pdp-a__modal[popover]').forEach(function(pop) {
      on(pop, 'click', function(e) {
        if (e.target === pop) pop.hidePopover();
      });
      // Tab / Shift+Tab wrap within the open panel instead of walking into
      // the dimmed page behind it (where the focused element is hidden).
      on(pop, 'keydown', function(e) {
        if (e.key !== 'Tab' || !pop.matches(':popover-open')) return;
        var stops = pop.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!stops.length) return;
        var first = stops[0], last = stops[stops.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    });

    /* ═══════════════ Sticky Add to Cart: one bar, Eight Sleep's pattern ═══════════════
       Measured on eightsleep.com 31 Oct 2026 (Work/2026-10-31-pdp-buybox/ref/
       EIGHTSLEEP-STICKY.md). Eight Sleep keeps exactly one checkout in view:
       the buy box's own, pinned to the bottom while you configure, then a
       page-level bar once the configurator is behind you. Here that is ONE bar:
       - buy box's Add to Cart below the screen → bar at the bottom: full width
         under 1024px ("bottom"), docked under the buy column from 1024px
         ("column"); shown from page load;
       - that button on screen → bar away, so one Add to Cart shows at a time;
       - past it → phones keep the bottom bar to the end of the page; desktop
         gets the floating "top" bar, which drops in as the header slides away,
         leaves after 100px of scrolling up (header back) and returns after
         100px down;
       - over the dark footer the bar turns light.
       Geometry is read fresh on every rAF-throttled scroll/resize, never IO
       (mistakes.md 2026-06-11). The button submits the main cart form through
       its form attribute, so the ATC handler above (with ticked add-ons) runs
       unchanged; its label, disabled state, price and wood + heater mirror the
       buy box. */
    (function initStickyAtc() {
      var bar = section.querySelector('[data-pdp-sticky]');
      var cartRow = section.querySelector('.pdp-a__cart-row');
      if (!bar || !cartRow) return;

      var infoCol = section.querySelector('.pdp-a__info');
      var footer = document.querySelector('.custom-footer') || document.querySelector('.shopify-section-group-footer-group');
      var stickyPrices = Array.prototype.slice.call(section.querySelectorAll('[data-pdp-sticky-price]'));
      var stickyBtns = Array.prototype.slice.call(section.querySelectorAll('.pdp-a__sticky-btn'));
      var stickyConfig = section.querySelector('[data-pdp-sticky-config]');
      var mqDesk = window.matchMedia('(min-width: 1024px)');
      var SCROLL_SWAP = 100; /* px of travel that hides / brings back the top bar (measured) */
      var chatEl = null;
      var chatPrev = '';

      /* The sub-line names the choice: "Japanese Cedar · Wi-Fi Control". */
      function syncStickyConfig() {
        if (!stickyConfig) return;
        var parts = [];
        ['.pdp-a__timber-card.is-selected .pdp-a__timber-name', '.pdp-a__heater-card.is-selected .pdp-a__heater-name'].forEach(function(sel) {
          var el = section.querySelector(sel);
          if (!el) return;
          var t = (el.firstChild && el.firstChild.nodeType === 3) ? el.firstChild.textContent : el.textContent;
          t = (t || '').trim();
          if (t) parts.push(t);
        });
        stickyConfig.textContent = parts.join(' · ');
      }

      /* Label + disabled state follow the buy box button, so "Adding…",
         "Added" and "Sold out" show in the bar too. */
      function syncStickyBtns() {
        if (!addBtn) return;
        var label = addBtn.textContent.trim();
        stickyBtns.forEach(function(b) {
          b.disabled = addBtn.disabled;
          if (addBtn.getAttribute('aria-disabled') === 'true') b.setAttribute('aria-disabled', 'true');
          else b.removeAttribute('aria-disabled');
          if (label && b.textContent !== label) b.textContent = label;
        });
      }

      syncStickyConfig();
      syncStickyBtns();

      if (priceEl && stickyPrices.length && 'MutationObserver' in window) {
        var moPrice = new MutationObserver(function() {
          stickyPrices.forEach(function(el) { el.textContent = priceEl.textContent; });
          syncStickyConfig();
        });
        moPrice.observe(priceEl, { childList: true, characterData: true, subtree: true });
        teardown.push(function() { moPrice.disconnect(); });
      }
      if (addBtn && stickyBtns.length && 'MutationObserver' in window) {
        var moBtn = new MutationObserver(syncStickyBtns);
        moBtn.observe(addBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, characterData: true, subtree: true });
        teardown.push(function() { moBtn.disconnect(); });
      }

      /* Locate a fixed bottom-right chat launcher (Rep AI or similar app
         embed — not part of the theme, so detect at runtime). */
      function findChatLauncher() {
        /* ZipChat (2026-07-11 verified live): mounts a 0x0 position:static
           #zipchat-shadow-host on body with an OPEN shadow root; the
           visible 48px launcher (position:fixed) lives INSIDE the shadow
           root — invisible to document-level queries and CSS, and failing
           every size/position check on the host. By 2026-10-02 the app
           renamed it from .widget-chat-container to #widget-chat-container;
           the class-only lookup had silently stopped matching and the
           bubble sat on the right third of the sticky Add to Cart. Match
           both.
           Look there first; the generic scan below stays as the fallback
           for any other chat app. */
        try {
          var zipHost = document.getElementById('zipchat-shadow-host');
          if (zipHost && zipHost.shadowRoot) {
            var zc = zipHost.shadowRoot.querySelector('#widget-chat-container, .widget-chat-container');
            if (zc) return zc;
          }
        } catch (err) { /* fall through to the generic scan */ }
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var nodes = document.querySelectorAll('body > div, body > section, body > aside, body > iframe');
        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          if (section.contains(el)) continue;
          var cs = window.getComputedStyle(el);
          if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
          var r = el.getBoundingClientRect();
          if (!r.width || !r.height || r.width > 220 || r.height > 220) continue;
          if (r.bottom > vh - 140 && r.right > vw - 200) return el;
        }
        return null;
      }

      /* Lift the launcher above the bar while the bar sits at the bottom
         and shares its columns (the docked desktop bar can end left of it).
         liftChat() is called on every sync and acts only on a change.
         31 Oct 2026: ZipChat re-mounts its launcher when the variant URL
         changes (timber/heater pick), dropping the lift, so the bubble sat on
         the bar's button again; a watcher on its shadow root re-applies it. */
      var chatWanted = false;
      /* Set by teardown (section unload, e.g. a size switch): queued frames and
         timers from this controller then do nothing, so a detached bar never
         re-measures or re-attaches the chat watcher. */
      var stickyDead = false;
      var stickyRaf = 0;
      var chatRaf = 0;
      var chatLift = '';
      var chatSkip = null;   /* launcher found clear of the bar: nothing to lift */
      var chatRetries = 0;
      var chatRetryTimer = 0;
      var chatMo = null;
      var chatCheckQueued = false;
      function chatSettled() {
        if (!chatWanted) return true;
        if (chatSkip && chatSkip.isConnected) return true;
        return !!(chatEl && chatEl.isConnected && chatEl.style.transform === chatLift);
      }
      function checkChat() {
        /* Cheap on scroll: leave the hunt for a launcher that has not mounted
           yet to the retry timer, and skip pages without ZipChat. */
        if (stickyDead || chatCheckQueued || chatRetryTimer) return;
        if (!chatEl && !chatSkip && !document.getElementById('zipchat-shadow-host')) return;
        chatCheckQueued = true;
        chatRaf = window.requestAnimationFrame(function() {
          chatRaf = 0;
          chatCheckQueued = false;
          if (stickyDead) return;
          if (!chatSettled()) { chatEl = null; chatSkip = null; applyChatLift(); }
        });
      }
      var chatMoHost = null;
      /* Launchers ZipChat has just inserted (first mount, or a re-mount after
         a page change): they go straight to the lifted spot, no slide up from
         the bar, since they have never been on screen. */
      var chatFresh = typeof WeakSet === 'function' ? new WeakSet() : null;
      var CHAT_SEL = '#widget-chat-container, .widget-chat-container';
      function markFresh(c) {
        if (!chatFresh) return;
        chatFresh.add(c);
        /* Once painted it is an ordinary launcher again: a bar that shows
           later slides it up with the bar. */
        window.requestAnimationFrame(function() { window.requestAnimationFrame(function() { chatFresh.delete(c); }); });
      }
      function watchChat() {
        if (stickyDead || !('MutationObserver' in window)) return;
        var host = document.getElementById('zipchat-shadow-host');
        if (!host || !host.shadowRoot || host === chatMoHost) return;
        if (chatMo) chatMo.disconnect();
        else teardown.push(function() { chatMo.disconnect(); });
        chatMoHost = host;
        chatMo = new MutationObserver(function(records) {
          var added = false;
          records.forEach(function(r) {
            Array.prototype.forEach.call(r.addedNodes, function(n) {
              if (n.nodeType !== 1) return;
              var found = n.matches(CHAT_SEL) ? [n] : n.querySelectorAll(CHAT_SEL);
              Array.prototype.forEach.call(found, function(c) { markFresh(c); added = true; });
            });
          });
          if (!chatWanted) return;
          /* Something changed in the widget: check now rather than at the next retry.
             A launcher just inserted is placed in this microtask, before it is ever painted. */
          if (chatRetryTimer) { clearTimeout(chatRetryTimer); chatRetryTimer = 0; }
          if (added) applyChatLift();
          else checkChat();
        });
        chatMo.observe(host.shadowRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      }
      /* ZipChat adds its host to <body> late (deferred load) and swaps it for
         a new one when the page changes: watch it from the moment it lands. */
      if ('MutationObserver' in window) {
        var chatHostMo = new MutationObserver(function() {
          var host = document.getElementById('zipchat-shadow-host');
          if (!host || host === chatMoHost) return;
          /* A launcher already inside a host that just landed has not been painted yet. */
          var inside = host.shadowRoot ? host.shadowRoot.querySelectorAll(CHAT_SEL) : [];
          Array.prototype.forEach.call(inside, markFresh);
          watchChat();
          if (chatWanted) {
            if (chatRetryTimer) { clearTimeout(chatRetryTimer); chatRetryTimer = 0; }
            if (inside.length) applyChatLift();
            else checkChat();
          }
        });
        chatHostMo.observe(document.body, { childList: true });
        teardown.push(function() { chatHostMo.disconnect(); });
      }
      function applyChatLift() {
        try {
          if (chatRetryTimer) { clearTimeout(chatRetryTimer); chatRetryTimer = 0; }
          if (chatWanted) {
            var el = findChatLauncher();
            if (!el) {
              /* ZipChat mounts ~4-10s after load. Without a retry the
                 one-shot lookup at bar-show time misses it and the
                 launcher lands ON TOP of the Add-to-Cart text (captured
                 live 2026-07-11). Keep looking while the bar is visible. */
              /* 8 quick looks (a re-mount takes ~0.3s), then every 1.5s. */
              if (chatRetries < 20) {
                chatRetries++;
                chatRetryTimer = setTimeout(function () {
                  chatRetryTimer = 0;
                  if (chatWanted && !stickyDead) applyChatLift();
                }, chatRetries <= 8 ? 250 : 1500);
              }
              return;
            }
            chatRetries = 0;
            watchChat();
            var er = el.getBoundingClientRect();
            var br = bar.getBoundingClientRect();
            if (er.right <= br.left || er.left >= br.right) {
              if (chatEl) { chatEl.style.transform = chatPrev; chatEl = null; }
              chatSkip = el;
              return;
            }
            chatSkip = null;
            var jump = false;
            if (el !== chatEl) {
              chatEl = el;
              chatPrev = el.style.transform || '';
              jump = !!(chatFresh && chatFresh.has(el));
            }
            chatLift = 'translateY(-' + (bar.offsetHeight + 8) + 'px)';
            if (jump) {
              chatEl.style.transition = 'none';
              chatEl.style.transform = chatLift;
              void chatEl.offsetWidth;
            }
            chatEl.style.transition = 'transform 280ms ease';
            chatEl.style.transform = chatLift;
          } else if (chatEl) {
            chatEl.style.transform = chatPrev;
            chatEl = null;
          }
        } catch (err) { /* chat lift is best-effort */ }
      }
      function liftChat(want) {
        if (want === chatWanted) { if (want) checkChat(); return; }
        chatWanted = want;
        chatSkip = null;
        applyChatLift();
      }
      teardown.push(function () { if (chatRetryTimer) clearTimeout(chatRetryTimer); });

      /* Docked desktop bar spans the buy column exactly. */
      var colLeft = null;
      var colWidth = null;
      function placeColumn() {
        if (!infoCol) return;
        var r = infoCol.getBoundingClientRect();
        var l = Math.round(r.left), w = Math.round(r.width);
        if (l === colLeft && w === colWidth) return;
        colLeft = l; colWidth = w;
        bar.style.setProperty('--pdp-bar-left', l + 'px');
        bar.style.setProperty('--pdp-bar-width', w + 'px');
      }

      var placement = bar.getAttribute('data-placement') || 'bottom';
      var stickyVisible = false;
      function setStickyVisible(on, instant) {
        if (on === stickyVisible) return;
        stickyVisible = on;
        if (instant) bar.classList.add('is-instant');
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) bar.removeAttribute('inert');
        else bar.setAttribute('inert', '');
        if (instant) { void bar.offsetWidth; bar.classList.remove('is-instant'); }
        if (on) syncStickyConfig();
      }
      /* Moving between bottom/column/top happens hidden and without a
         transition, so the bar never flies across the page; it then
         enters from the new edge. */
      function setPlacement(next) {
        if (next === placement) return;
        bar.classList.add('is-instant');
        setStickyVisible(false);
        bar.setAttribute('data-placement', next);
        placement = next;
        void bar.offsetWidth;
        bar.classList.remove('is-instant');
      }

      /* The sticky header covers the top of the page, so the buy box's
         button counts as on screen only below it (its layout height, which a
         slide-away does not change, so the two states cannot flicker). */
      var headerEl = null;
      Array.prototype.forEach.call(document.querySelectorAll('.shopify-section-group-header-group'), function(el) {
        var pos = window.getComputedStyle(el).position;
        if (!headerEl && (pos === 'sticky' || pos === 'fixed')) headerEl = el;
      });
      var headerInset = 0;
      function measureHeader() { headerInset = headerEl ? headerEl.offsetHeight : 0; }
      measureHeader();

      document.body.classList.add('pdp-a-has-bar');
      var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var runDir = 0;
      var runStart = lastY;
      var inTop = false;
      var topOn = false;
      var first = true;
      var stickyTick = false;
      function syncSticky() {
        if (stickyTick || stickyDead) return;
        stickyTick = true;
        stickyRaf = window.requestAnimationFrame(function() {
          stickyRaf = 0;
          stickyTick = false;
          if (stickyDead) return;
          var y = window.pageYOffset || document.documentElement.scrollTop || 0;
          var dy = y - lastY;
          if (dy > 0 && runDir !== 1) { runDir = 1; runStart = lastY; }
          else if (dy < 0 && runDir !== -1) { runDir = -1; runStart = lastY; }
          lastY = y;

          var vh = window.innerHeight || document.documentElement.clientHeight;
          var cartR = cartRow.getBoundingClientRect();
          var atcOnScreen = cartR.bottom > headerInset && cartR.top < vh;
          var pastAtc = cartR.bottom <= headerInset;
          var desk = mqDesk.matches;
          var next = desk ? (pastAtc ? 'top' : 'column') : 'bottom';

          if (next === 'top') {
            if (!inTop) { inTop = true; topOn = true; }
            else if (runDir === -1 && runStart - y >= SCROLL_SWAP) topOn = false;
            else if (runDir === 1 && y - runStart >= SCROLL_SWAP) topOn = true;
          } else {
            inTop = false;
          }
          var show = !atcOnScreen && (next !== 'top' || topOn);

          if (next === 'column') placeColumn();
          setPlacement(next);
          setStickyVisible(show, first);
          first = false;

          /* Light over the dark footer, judged at the bar's middle (kept as is
             while the bar leaves, so it does not change colour on the way out). */
          if (show) {
            var inverted = false;
            if (footer) {
              var padTop = parseFloat(window.getComputedStyle(bar).paddingTop) || 0;
              var h = bar.offsetHeight;
              var mid = next === 'top' ? padTop + (h - padTop) / 2 : vh - h / 2;
              inverted = footer.getBoundingClientRect().top < mid;
            }
            bar.classList.toggle('is-inverted', inverted);
          }

          document.body.classList.toggle('pdp-a-bar-top', show && next === 'top');
          /* New size or placement: the launcher's overlap and lift are re-judged. */
          var geom = next + ':' + window.innerWidth + 'x' + vh;
          if (geom !== chatGeom) { chatGeom = geom; chatSkip = null; chatLift = ''; }
          liftChat(show && next !== 'top');
        });
      }
      var chatGeom = '';
      on(window, 'scroll', syncSticky, { passive: true });
      on(window, 'resize', function() { measureHeader(); syncSticky(); }, { passive: true });
      /* Keyboard focus moving into the hidden header brings it back, the way
         a scroll up does. */
      if (headerEl) {
        on(headerEl, 'focusin', function() {
          if (!inTop || !topOn) return;
          topOn = false;
          runDir = 0;
          syncSticky();
        });
      }
      syncSticky();
      teardown.push(function() {
        liftChat(false);
        stickyDead = true;
        if (stickyRaf) window.cancelAnimationFrame(stickyRaf);
        if (chatRaf) window.cancelAnimationFrame(chatRaf);
        if (chatRetryTimer) { clearTimeout(chatRetryTimer); chatRetryTimer = 0; }
        document.body.classList.remove('pdp-a-has-bar', 'pdp-a-bar-top');
      });
    })();

    /* ═══════════════ Shop Pay line in the site font ═══════════════ */
    /* Shop Pay Installments draws "From $X/mo with Shop" in its own font (GTStandard)
       inside an open shadow root, where the theme's CSS cannot reach. Colour, size and
       letter-spacing already inherit from the price block; one adopted rule makes the
       font inherit too, and the amount takes the site's 500 weight instead of bold
       (Viktor 25 Oct: "unify this font as rest of site is"). Id selectors outrank the
       component's utility classes, so no !important is needed. */
    (function() {
      if (typeof CSSStyleSheet === 'undefined' || !('adoptedStyleSheets' in Document.prototype)) return;
      var sheet;
      try {
        sheet = new CSSStyleSheet();
        sheet.replaceSync('#shopify-installments, #shopify-installments span { font-family: inherit; } #shopify-installments .font-bold { font-weight: 500; color: var(--text-primary, #111410); }');
      } catch (e) { return; }
      function adopt() {
        section.querySelectorAll('shopify-payment-terms').forEach(function(host) {
          var root = host.shadowRoot;
          if (!root || root.adoptedStyleSheets.indexOf(sheet) !== -1) return;
          root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
        });
      }
      if (window.customElements && customElements.whenDefined) customElements.whenDefined('shopify-payment-terms').then(adopt);
      adopt();
      section.querySelectorAll('.pdp-a__terms-form').forEach(function(form) {
        var mo = new MutationObserver(adopt);
        mo.observe(form, { childList: true, subtree: true });
        teardown.push(function() { mo.disconnect(); });
      });
    })();

    /* ═══════════════ Teardown on Shopify section unload ═══════════════ */
    /* Removed only by its own section's unload: another section's unload (Theme
       Editor, or the size switch in custom-pdp-model-swap.js) must not use it up. */
    document.addEventListener('shopify:section:unload', function onUnload(e) {
      if (!section || !e.target || !e.target.contains(section)) return;
      document.removeEventListener('shopify:section:unload', onUnload);
      cleanup();
    });
  })();
